import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";
import { VRSTA_IDENTIFIKATORA } from "../../../../enums";

const Index = ({ field, index, update, nazivPolja }: any) => {
  const { register, getValues, setValue, watch } = useFormContext();
  const nazivPoljaId = useMemo(() => `${nazivPolja}.id`, [index]);
  const nazivPoljaOpis = useMemo(() => `${nazivPolja}.opis`, [index]);
  const identifikatori = getValues("identifikatori");
  const opis = useMemo(() => {
    if (field.vrstaIdentifikatora.id) {
      return identifikatori.find(
        (identifikator: any) =>
          identifikator.id === parseInt(field.vrstaIdentifikatora.id)
      ).opis;
    }
    return "";
  }, [field]);

  return (
    <>
      <FormControl fullWidth error={!daLiJePoljeValidno(nazivPoljaId)}>
        <InputLabel id={nazivPoljaId}>Vrsta identifikatora (Type of identifier)</InputLabel>
        <Select
          labelId={nazivPoljaId}
          id={nazivPoljaId}
          disabled={true}
          defaultValue={VRSTA_IDENTIFIKATORA.TIN}
          value={VRSTA_IDENTIFIKATORA.TIN}
          label="Vrsta identifikatora (Type of identifier)"
          variant={"standard"}
          {...register(nazivPoljaId, {
            value: VRSTA_IDENTIFIKATORA.TIN,
          })}
        >
          {identifikatori.map((identifikator: any, key: number) => (
            <MenuItem value={identifikator.id} key={key}>
              {identifikator.opis}
            </MenuItem>
          ))}
        </Select>
        <PorukaGreskePolja nazivPolja={nazivPoljaId} />
      </FormControl>
      {field.vrstaIdentifikatora.id && (
        <Input type={"hidden"} value={opis} {...register(nazivPoljaOpis)} />
      )}
    </>
  );
};

export default Index;
